import Vue from 'vue';
import VSanitize from "v-sanitize";

Vue.use(VSanitize);
